import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import getImageUrl from '../utils/getImageUrl'
import { color, mixin, bp, borderRadiusSmall } from '../globalStyles'
import BackgroundImage from './BackgroundImage'
import {
  IconDuration,
  IconLength,
  IconClassification
} from '../components/icons'

const CardInner = styled.div`
  @media (${bp.desktop}) {
    margin: 1rem;
  }
`
const Title = styled.h4`
  margin-bottom: 0.5rem;
`
const Details = styled.div`
  font-size: 1.2rem;

  @media (${bp.desktop}) {
    font-size: 0.9em;
    display: flex;

    & > * {
      margin-right: 1.5rem;
    }
  }
`
const Detail = styled.div`
  margin-bottom: 0;
  line-height: 1.4;
  font-weight: 400;
  color: inherit;
  display: flex;
  align-items: center;

  & > *:nth-child(1) {
    margin-right: 1rem;
  }
`
const Image = styled.div`
  width: 10rem;
  margin-left: 1rem;
  flex-shrink: 0;
  position: relative;
  border-radius: ${borderRadiusSmall};
  overflow: hidden;
  background-color: ${color.lightGrey};

  .BackgroundImage {
    background-image: url(${props => props.imageSmall});
  }

  @media (${bp.desktop}) {
    .BackgroundImage {
      background-image: url(${props => props.imageLarge});
    }
  }
`
const Card = styled(Link)`
  ${mixin.card};
  ${mixin.cardHover};
  background: white;
  color: inherit;
  display: flex;
  align-items: stretch;
  justify-content: space-between;

  @media (${bp.desktop}) {
    flex-direction: column;
    border: none;
    box-shadow: none;
    border-radius: ${borderRadiusSmall};
    padding: 0;

    &:hover,
    &:focus {
      box-shadow: none;
    }

    ${Image} {
      order: -1;
      height: 20rem;
      width: 100%;
      margin: 0;
    }
  }
`

const TrackCard = ({ track }) => {
  if (!track.fields) return null
  const {
    title,
    slug,
    mainImage,
    trackDuration: duration,
    trackClassification: classification,
    trackLength: length
  } = track.fields
  const imageSmall = getImageUrl(mainImage, 200)
  const imageLarge = getImageUrl(mainImage, 400)
  return (
    <Card to={`/walks/${slug}`} className='Card'>
      <CardInner>
        {title && <Title>{title}</Title>}
        <Details>
          {length && (
            <Detail>
              <IconLength />
              {length} km
            </Detail>
          )}
          {duration && (
            <Detail>
              <IconDuration />
              {duration} hours
            </Detail>
          )}
          {classification && (
            <Detail>
              <IconClassification />Grade {classification}
            </Detail>
          )}
        </Details>
      </CardInner>
      <Image imageSmall={imageSmall} imageLarge={imageLarge}>
        <BackgroundImage />
      </Image>
    </Card>
  )
}

TrackCard.propTypes = {
  track: PropTypes.object.isRequired
}

export default TrackCard



// WEBPACK FOOTER //
// ./src/components/TrackCard.js